import { render, staticRenderFns } from "./headerTop.vue?vue&type=template&id=422a6520&scoped=true&"
import script from "./headerTop.vue?vue&type=script&lang=js&"
export * from "./headerTop.vue?vue&type=script&lang=js&"
import style0 from "./headerTop.vue?vue&type=style&index=0&id=422a6520&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422a6520",
  null
  
)

export default component.exports